const portalApi = {
  signinMessages: "/signinmessages",
  userInfo: "/userinfo",
};

export default portalApi;
